import React from 'react'
import { Button, Flex, Text } from '@workwhile/ui'
import { AccordionCard } from 'components/AccordionCard'
import { useRuleDetailContextValue } from '../context/RuleDetailProvider'
import { useRuleDetailWorkflowsContextValue } from '../context/RuleDetailWorkflowsProvider'
import { useDetachJurisdictionFlowContextValue } from '../workflows/DetachJurisdictionFlow/context/DetachJurisdictionFlowProvider'
import { JurisdictionsEmptyState } from './JurisdictionsEmptyState'
import { JurisdictionList } from './JurisdictionList'

export const JurisdictionsSection = () => {
  const {
    state: { jurisdictionIds, jurisdictions },
  } = useRuleDetailContextValue()

  const { attachJurisdictionFlow } = useRuleDetailWorkflowsContextValue()
  const {
    actions: { detach },
  } = useDetachJurisdictionFlowContextValue()

  const jurisdictionMap = new Map(jurisdictions.map((j) => [j.id, j]))

  return (
    <AccordionCard
      title={
        <Flex
          justifyContent="space-between"
          alignItems="center"
          gap={2}
          width="100%"
        >
          <Text fontSize={2} color="lightText">
            Jurisdictions ({jurisdictionIds.length})
          </Text>
          <Button
            variant="secondary"
            kind="small"
            onClick={attachJurisdictionFlow.open}
          >
            Attach
          </Button>
        </Flex>
      }
    >
      {jurisdictionIds.length === 0 ? (
        <JurisdictionsEmptyState />
      ) : (
        <JurisdictionList
          jurisdictionIds={jurisdictionIds}
          jurisdictionMap={jurisdictionMap}
          onDetach={detach}
        />
      )}
    </AccordionCard>
  )
}
